import { IconToggleLeftFilled, IconToggleRightFilled, IconX } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react'
import { Badge, Modal } from 'react-bootstrap';
import TableComponent from '../../../components/DataTable/TableComponent';
import { urlApi } from '../../../api/url.api';
import { getApi } from '../../../api/call.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { toast } from 'sonner';
import { dateTimeConverter } from '../../../utils/dateTimeConverter';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';

const BankList = ({ userData }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    const getList = async () => {
        loadingShow();
        let resp = await getApi(urlApi.userBankList + userData?._id + "?page=" + activePage + "&limit=" + perPage);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            });
            handleShow();
        } else {
            setTableData({
                data: [],
                totalCount: 0
            })
            toast.error(resp?.message)
        }
    }

    useEffect(() => {
        if (show) {
            getList();
        }
        return () => {

        };
    }, [activePage, perPage]);

    async function updateStatus(id, status) {
        loadingShow();
        let resp = await getApi(`${urlApi.updateBankStatusOfUser}${userData?._id}/${id}/${status}`);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getList();
        } else {
            toast.error(resp.message);
        }
    }

    const columns = [
        { name: "Sl. No", center: "true", width: "60px", selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Account No.", center: "true", selector: (row) => row?.accountNumber, cell: (row) => (
                <div>
                    {row?.isCurrent && <Badge bg='success'>Primary</Badge>}
                    <p className='!my-2'>{row?.accountNumber}</p>
                </div>
            ),
        },
        { name: "Account Holder Name", center: "true", selector: (row) => row?.accountHolderName, cell: (row) => row?.accountHolderName || "--", }, {
            name: "IFSC Code", center: "true", selector: (row) => row?.ifscCode, cell: (row) =>
                <p>{row?.ifscCode}</p>
        }, {
            name: "Created", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <p>{dateTimeConverter(row?.createdAt)}</p>
        }, {
            name: "Status", center: "true", selector: (row) => row?.status, cell: (row) =>
                <ConfirmationModal
                    buttonComponent={row?.status == 1 ? <IconToggleRightFilled className='text-green-600 cursor-pointer transition-all' /> : <IconToggleLeftFilled className='text-red-700 cursor-pointer transition-all' />}
                    confirmationText={`Are You Sure Want To ${row?.status == 1 ? 'Deactivate' : "Activate"} This bank ?`}
                    onConfirm={() => updateStatus(row?._id, row?.status == 1 ? 2 : 1)}
                />
        },

    ]

    return (
        <div>
            <button className='bg-lime-700 !px-5 !py-1.5 rounded-full text-sm text-white' onClick={getList}>Banks</button>
            <Modal show={show} onHide={handleClose} size='xl' >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold"> Banks Of {userData?.name}</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <TableComponent
                        columns={columns}
                        data={tableData.data}
                        totalRows={tableData.totalCount}
                        isPagination={true}
                        handlePageChange={(e) => handlePageChange(e)}
                        handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

                </Modal.Body>
            </Modal>
        </div>
    )
}

export default BankList